module.exports = __webpack_public_path__ + "9b871edceee97a98deb993f619d33b05.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/coat-s.png
// module id = 1259
// module chunks = 0